import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts';
import type { Role } from '@rsmaids/shared/constants/roles';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: Role[];
  redirectTo?: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  allowedRoles = [],
  redirectTo = '/login',
}) => {
  const { authState } = useAuth();
  const { isLoggedIn, isLoading, user } = authState;
  const location = useLocation();

  if (isLoading) {
    return null;
  }

  if (!isLoggedIn || !user) {
    return <Navigate to={redirectTo} replace />;
  }

  if (allowedRoles.length > 0) {
    const hasRequiredRole = allowedRoles.includes(user.role as Role);
    if (!hasRequiredRole) {
      return (
        <Navigate
          to="/unauthorized"
          replace
          state={{
            from: `${location.pathname}${location.search}${location.hash}`,
          }}
        />
      );
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;
